export enum ReduceAmountType {
    FIXED = "FIXED",
    PERCENTAGE = "PERCENTAGE"
}
